import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsGeneralReportComponent } from './fields-interventions-general-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsGeneralReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsGeneralReportComponent]
})
export class FieldsInterventionsGeneralReportModule { }
